/*
 * Common functions used site wide
 * Only include in here if highly likely to be needed on all pages
 */

require('../../../../core/js/plugins/mtc_hoverintent');
require('../../../../core/js/plugins/mtc_mobileMenu');
require('../../../../core/js/plugins/mtc_unveil');
require('../../../../core/js/plugins/mtc_overlay');
require('../../../../core/js/plugins/mtc_perfectScroll');
require('../../../../core/js/plugins/mtc_picturefill');

require('../site_scripts/mtc_debouncer');
require('../site_scripts/mtc_get_breakpoints');
require('../site_scripts/mtc_matches_media_query');
require('../site_scripts/mtc_window_width');
require('../site_scripts/mtc_phone_click_tracking');
require('../site_scripts/mtc_mega_menu');
require('../site_scripts/mtc_keyword_search');
require('../site_scripts/mtc_mobile_menu');
require('../site_scripts/mtc_footer_menu');
require('../site_scripts/mtc_lazy_load_images');
require('../site_scripts/mtc_killclick');
require('../site_scripts/mtc_youtube_overlay')
require('../site_scripts/mtc_reviews_overlay')
require('../site_scripts/mtc_car_tab_headers');
require('../site_scripts/mtc_slide_fade_toggle');
require('../site_scripts/mtc_countdown_banner');
require('../site_scripts/mtc_cookies');
require('../site_scripts/mtc_read_more_scroll');
require('../site_scripts/mtc_save_car');
